module.exports = __webpack_public_path__ + "img/种植（个人）.1b37bef7.png";